<template>
  <div class="team">
    <div class="introduce-box">
      <div class="icon-box">
        <div class="icon">
          <div
            class="head"
            :style="{
              'background-image': `url(${
                teamInfo.avatar ? teamInfo.avatar : ''
              })`,
            }"
          ></div>
          <div class="frame"></div>
        </div>
      </div>
      <div class="intro-box">
        <div class="introduce">
          <div class="header wrap">
            <div class="title">
              <div class="label-box">
                <span class="label-shadow">{{ teamInfo.name ? teamInfo.name : "-" }}</span>
                <span class="label-text">{{ teamInfo.name ? teamInfo.name : "-" }}</span>
              </div>
            </div>
            <ui-frame-bg
              class="focus-box"
              :colorType="teamInfo.isFollowed ? 'blue' : 'yellow'"
              @click.native.stop="handleFocus(teamInfo.teamCode, !teamInfo.isFollowed)"
            >
              <i :class="{ focus: !teamInfo.isFollowed, unfocus: teamInfo.isFollowed }"></i>
              <div class="label-box">
                <span class="label-shadow">{{ teamInfo.isFollowed ? '已关注' : '关注' }}</span>
                <span class="label-text">{{ teamInfo.isFollowed ? '已关注' : '关注' }}</span>
              </div>
            </ui-frame-bg>
          </div>
          <div class="des wrap">
            {{ teamInfo.desc ? teamInfo.desc : default_introduce }}
          </div>
          <div class="line"></div>
          <ul class="rank wrap">
            <li class="info-rank">
              <i></i>赛季排名
              <span>{{ teamInfo.rank ? teamInfo.rank : "-" }}</span>
            </li>
            <li class="info-popularity">
              <i></i>人气值
              <span>{{ teamInfo.popularity ? teamInfo.popularity : 0 }}</span>
            </li>
            <li class="info-follow">
              <i></i>战队关注数
              <span>{{
                teamInfo.followNum || teamInfo.followNum == 0
                  ? teamInfo.followNum
                  : "-"
              }}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="data-box">
      <div class="base-data">
        <div class="title-box">
          <div class="title">
            <div class="label-box">
              <span class="label-shadow">赛事数据</span>
              <span class="label-text">赛事数据</span>
            </div>
          </div>
          <div class="switch-source" v-if="teamHistoryList && teamHistoryList.length != 0">
            <ui-frame-bg class="switch-btn" colorType="blue" hook @click.native="showSelect = !showSelect">
              <div class="label-box">
                <span class="label-shadow">{{ seasonName }}</span>
                <span class="label-text">{{ seasonName }}</span>
              </div>
              <i :class="{ active: showSelect }"></i>
            </ui-frame-bg>
            <SelectList
              class="switch-list-box"
              v-show="showSelect"
              :list="teamHistoryList"
              :defaultID="subSeasonID"
              @handleSwitch="handleSwitch"
            ></SelectList>
          </div>
        </div>
        <div v-show="showBaseData" class="content" ref="baseData"></div>
        <Interdict v-show="!showBaseData" tip="暂无数据，首场比赛后即可查看" />
      </div>
      <!-- 历史荣耀 -->
      <div class="history-reward">
        <div class="title-box">
          <div class="title">
            <div class="label-box">
              <span class="label-shadow">历史荣耀</span>
              <span class="label-text">历史荣耀</span>
            </div>
          </div>
        </div>
        <div
          class="content"
          v-if="
            teamInfo.length != 0 &&
            teamInfo.history &&
            teamInfo.history.length != 0
          "
        >
          <div class="swiper-container">
            <div class="swiper-wrapper">
              <div
                class="swiper-slide"
                v-for="(glory, key) in teamInfo.history"
                :key="key"
                :style="{ 'background-image': `url(${glory})` }"
              ></div>
              <div
                class="swiper-slide"
                v-if="teamInfo.history && teamInfo.history.length % 2 != 0"
              ></div>
            </div>
          </div>
          <div v-if="teamInfo.length != 0">
            <div class="swiper-button-prev"></div>
            <div class="swiper-button-next"></div>
          </div>
        </div>
        <Interdict v-else tip="战队正在努力夺冠中~" />
      </div>
    </div>
    <Prompt ref="prompt"></Prompt>
  </div>
</template>

<script>
import SelectList from "@/components/select";
import * as api from "@/service/index";
import * as echarts from "echarts";
import Swiper from "swiper";
import "swiper/dist/css/swiper.min.css";
import { mapState } from "vuex";
import Prompt from "@/components/prompt";
import { getOption, updataOption } from "@/utils/initEcharts";
import uiFrameBg from "@/components/ui-frame-bg";
import Interdict from "@/components/interdict";

export default {
  components: {
    SelectList,
    Prompt,
    uiFrameBg,
    Interdict
  },
  props: {
    subTeam: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      showSelect: false,
      teamInfo: {},
      subSeasonID: '',
      seasonList: [],
      teamHistoryList: [],
      default_introduce: "这个战队，什么话都没留下～ ",
      option: {},
      myChart: null,
      seasonName: "",
      inRequire: false,
      showBaseData: false,
    };
  },
  computed: {
    ...mapState(["token", "uid", "seasonInfo"]),
    isOnChange({ seasonInfo, subTeam }) {
      return { seasonInfo, subTeam }
    }
  },
  watch: {
    isOnChange: {
      handler(newVal) {
        if(newVal && Object.keys(newVal).length >= 2) {
          let seasonInfo = newVal.seasonInfo;
          let subTeam = newVal.subTeam;

          if(Object.keys(seasonInfo).length != 0 && Object.keys(subTeam).length != 0) {
            this.subSeasonID = seasonInfo.id;
            this.getMembersInfo(subTeam);
          }
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    getMembersInfo(data = {}) { 
      let subTeam = this.$route.params.subTeam;
      if (subTeam) {
        if (Object.keys(subTeam).length != 0) {
          this.getTeamInfo(subTeam);
        }
      } else {
        if (Object.keys(data).length != 0) {
          this.getTeamInfo(data);
        }
      }
    },
    getTeamInfo(subTeam) {
      this.teamInfo = subTeam;
      let historyList = this.teamInfo.teamHistoryList;
      // 默认显示最近赛季的数据
      if (historyList && historyList.length != 0) {
        historyList.forEach((match) => {
          match.id = match.seasonId;
          match.name = match.seasonName;
        });
        this.teamHistoryList = historyList;

        this.seasonName = this.teamHistoryList.find(item => item.seasonId == this.subSeasonID)?.seasonName || '';
      }else {
        this.teamHistoryList = [];
      }

      // 返回数据后，初始化swiper
      this.$nextTick(() => {
        this.initSwiper();

        // 渲染赛季数据
        let data = this.teamInfo.matchData || {};
        // console.log('初始化数据',data);
        this.showData(data, () => {
          this.initEcharts();
          this.updataEcharts(data)
        });
      })

      // 埋点
      if(typeof tapdb == 'undefined') return;
      tapdb.trackEvent('战队详情', {
        '#team_id': this.teamInfo.name
      });
    },
    initEcharts() {
      let chartDom = this.$refs.baseData;
      this.myChart = echarts.init(chartDom);
      this.option = getOption(chartDom, 'team');
      this.option && this.myChart.setOption(this.option);
      chartDom.childNodes[0].style.position = "absolute";
    },
    updataEcharts(subSeason) {
      this.option = updataOption(subSeason, this.option, "team");
      this.option && this.myChart.setOption(this.option);
    },
     handleSwitch (seasonId) {
      if(seasonId == this.subSeasonID) return;
      this.subSeasonID = seasonId
      const subSeason = this.teamHistoryList.find((item) => item.seasonId == seasonId);
      this.seasonName = subSeason.name;
      if(!this.token) return;
      let datas = {
        token: this.token,
        seasonId: 14,
        teamCode : subSeason.teamCode
      }
      api.reqTeamInfo(datas).then((res)=>{
        const { data } = res
        if(data.matchData){
          this.showData(data.matchData, () => {
            this.initEcharts();
            this.updataEcharts(data.matchData)
          });
        }
      }).catch((err)=>{
        console.log(err);
       });
      this.showSelect = false;
    },
    showData(matchData, callback) {
  
      if (
        matchData.maxAvgKill &&
        matchData.maxAvgAccuracy &&
        matchData.maxAvgSurviveTime &&
        matchData.maxAvgTravelDistance &&
        matchData.maxAvgDamage
      ) {
        // 该战队数据为0时，不显示五边形图
        if (
          (!matchData.teamAvgAccuracy ||
            matchData.teamAvgAccuracy == 0 ||
            matchData.teamAvgAccuracy == "0.00") &&
          (!matchData.teamAvgDamage ||
            matchData.teamAvgDamage == 0 ||
            matchData.teamAvgDamage == "0.00") &&
          (!matchData.teamAvgKill ||
            matchData.teamAvgKill == 0 ||
            matchData.teamAvgKill == "0.00") &&
          (!matchData.teamAvgSurviveTime ||
            matchData.teamAvgSurviveTime == 0 ||
            matchData.teamAvgSurviveTime == "0.00") &&
          (!matchData.teamAvgTravelDistance ||
            matchData.teamAvgTravelDistance == 0 ||
            matchData.teamAvgTravelDistance == "0.00")
        ) {
          this.showBaseData = false;
        } else {
          this.showBaseData = true;
          setTimeout(() => {
            callback();
          }, 0)
        }
      }else {
        this.showBaseData = false;
      }
      // console.log('object',this.showBaseData);
    },
    initSwiper() {
      new Swiper(".swiper-container", {
        autoplay: false,
        slidesPerView: 2,
        slidesPerGroup: 2,
        spaceBetween: "5.07%",
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      });
    },
    handleFocus(teamCode, status) {
      if (!this.inRequire) {
        this.inRequire = true;
        let data_ = {};
        if (this.token) {
          data_ = {
            // token: decodeURIComponent(this.token),
            seasonId: this.subSeasonID,
            teamCode: teamCode,
            status: status ? 1 : 0,
          };
        } else if (this.uid) {
          data_ = {
            uid: this.uid,
            team_code: teamCode,
            status: status ? true : false,
          };
        }
        if(!this.token) return;
        try{
          api.reqFocusStatus(this.token,data_).then((response) => {
          if (response.status == 200) {
            this.teamInfo.isFollowed = status ? 1 : 0;
            if (status) {
              this.teamInfo.followNum += 1;
            } else {
              this.teamInfo.followNum -= 1;
            }
            this.$refs.prompt.setMsg(status ? "关注成功" : "取消关注成功");
          }

          this.inRequire = false;
        });
        }catch(err){
          console.log(err);
        }
        
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/teams/detail-team";
</style>